import React from 'react';
import styles from './motorMilestones.module.css';
import MotorMilestonesChart from './MotorMilestonesChart';

/**
 * Gráfico das janelas com a legenda. `rows`, `current` e `corrected` vêm de
 * buildMotorMilestonesJob; `currentLabel`: rótulo da linha da idade atual.
 */
const MotorMilestonesPanel = ({ rows, current, corrected, currentLabel }) => (
  <div className={styles.panel}>
    <MotorMilestonesChart rows={rows} current={current} corrected={corrected} currentLabel={currentLabel} />
    <div className={styles.legend}>
      <span className={styles.legendItem}><span className={styles.legendOuter} />Janela P1 a P99</span>
      <span className={styles.legendItem}><span className={styles.legendInner} />P3 a P97</span>
      <span className={styles.legendItem}><span className={styles.legendMedian} />Mediana</span>
      <span className={styles.legendItem}><span className={styles.legendDot} />Conquista</span>
      {current && <span className={styles.legendItem}><span className={styles.legendCurrent} />Idade atual</span>}
    </div>
  </div>
);

export default MotorMilestonesPanel;
